import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useSelectedOnBehalfOfUserId } from '@ms/yammer-hooks/dist/analyticsSettings/selectors';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useFeatureAccessInsights, useFeatureAccessInsightsStatus } from '@ms/yammer-hooks/dist/featureAccessInsights';

import { UseUIFeatureCheck } from '../types';

export {
  useIsCampaignsEntryPointVisible as useIsInsightsCampaignEnabled,
  useIsLeadersInsightsEntryPointVisible as useIsInsightsLeadersOrgNavigationEnabled,
  useIsMyInsightsEntryPointVisible as useIsInsightsLeadersMyInsightsNavigationEnabled,
  useIsQnAMyInsightsEntryPointVisible as useIsInsightsQnAMyInsightsEnabled,
  useIsQnAOrgEntryPointVisible as useIsInsightsQnAOrgEnabled,
} from '@ms/yammer-hooks/dist/insights';

const useInsightsLeadersPrerequisites: UseUIFeatureCheck<[], boolean | undefined> = () => {
  const vivaInsightsLeadersExperiment = useExperimentTreatmentWithoutReporting(Experiment.VivaInsightsLeaders);
  const vivaEngagePremiumExperiment = useExperimentTreatmentWithoutReporting(Experiment.VivaEngagePremium);
  const featureAccessInsights = useFeatureAccessInsights();
  const featureAccessInsightsStatus = useFeatureAccessInsightsStatus();
  const selectedOnBehalfOfUserId = useSelectedOnBehalfOfUserId();

  if (vivaInsightsLeadersExperiment !== true && vivaEngagePremiumExperiment !== true) {
    return false;
  }

  if (
    featureAccessInsightsStatus === 'pending' ||
    featureAccessInsights?.onBehalfOfUserId !== selectedOnBehalfOfUserId
  ) {
    return undefined;
  }

  return true;
};

export const useIsInsightsLeadersMyInsightsPageEnabled: UseUIFeatureCheck<[], boolean | undefined> = () => {
  const insightsLeadersPrerequisites = useInsightsLeadersPrerequisites();
  const featureAccessInsights = useFeatureAccessInsights();

  return insightsLeadersPrerequisites && featureAccessInsights?.canViewActivity === true;
};

export const useIsInsightsLeadersOrgPageEnabled: UseUIFeatureCheck<[], boolean | undefined> = () => {
  const insightsLeadersPrerequisites = useInsightsLeadersPrerequisites();
  const featureAccessInsights = useFeatureAccessInsights();

  return insightsLeadersPrerequisites && featureAccessInsights?.canViewLeadershipActivity === true;
};

export const useIsUserInsightsEnabled: UseUIFeatureCheck = () =>
  useExperimentTreatmentWithoutReporting(Experiment.UserInsights) === true;
